// Staging console → API de staging (staging-kredit-api), no DEV ni QA.
export const environment = {
  production: false,
  inactive: false,

  BASE_LA: 'https://staging-kredit-api.creditotal.online',
  BASE_RECHARGE: 'https://staging-recharge-api.creditotal.online',
  BASE_FORNT2: 'https://staging-console.creditotal.online',
  // El portal de los comercios. De aca sale la direccion propia de cada uno
  // (<base>/c/<CODIGO>), la que se le entrega para que su gente entre.
  BASE_PORTAL_COMERCIOS: 'https://staging-comercio.creditotal.online',
  // El dominio de la dirección propia de cada comercio en staging (<acrónimo>.mc-staging.creditotal.online),
  // el mismo URL_PROPIA_DOMINIO_BASE del núcleo y del portal de staging.
  URL_PROPIA_DOMINIO_BASE: 'mc-staging.creditotal.online',
  BASE_FORNT: 'https://staging-app.creditotal.online',
  redirectRoute: '/console/create-constacts',
  searchClient: '/console/create-constacts',
  psicometrico: '/console/psicometrico',
  initRoute: '/console/search-client',
  BASE_BDV_API: 'https://staging-api-bdv-payment-button.creditotal.online',

  externalPsicometrico: 'https://www.acredita.com.ve:8860/psicometrico/home_test.php',

  loginRoute: '/login',
  logoutRoute: '/logout',

  socketBase: {
    SOCKET_ENDPOINT: 'https://staging-api-socket.creditotal.online/',
  },

  ClieID: '12',
  CED: '11314836',
  IP_LOCAL: '159.223.176.142',
  REWARDS_FRONT_URL: 'https://staging-app-rewards.creditotal.online',

  ONBOARDING_LA: 'https://staging-api-onboarding.creditotal.online',

  ANALYSIS_REPORT: 'https://analytics-api.creditotal.online',

  BASE_CASH_REGISTER_PAYMENT: 'https://staging-api-payment-pos.creditotal.online',

  TRUSTX: 'https://trustx-dev-api.akeela.co',
};
